module.exports = __webpack_public_path__ + "img/deliveryUnload.37ad204c.png";